import { TableCell, TableRow } from "@mui/material";
import styled from "styled-components";

type AccountHistoryRowRTemplateProps = {
  date?: string;
  debit?: JSX.Element | string;
  credit?: JSX.Element | string;
  balance?: JSX.Element | string;
};

export default function SummaryRowTemplate(
  props: AccountHistoryRowRTemplateProps
) {
  return (
    <TableRow>
      <Cell>{props.date}</Cell>
      <Cell>{props.debit}</Cell>
      <Cell>{props.credit}</Cell>
      <Cell>{props.balance}</Cell>
    </TableRow>
  );
}

const Cell = styled(TableCell)`
  font-size: 16px !important;
  text-align: center !important;
`;
